import React from 'react'
import PropTypes from 'prop-types'
import { Review } from 'hhsoig-design-system-core'

export const ReviewItems = ({ items }) => {
  return items.map(({ field_name, heading, onClick, value }, index) => (
    <Review
      key={`${field_name}_${index}`}
      heading={heading}
      onEditClick={() => onClick(field_name)}
      editHref="javascript:void(0)"
    >
      {value}
    </Review>
  ))
}

ReviewItems.propTypes = {
  items: PropTypes.array.isRequired
}
